import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=19d7469a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=19d7469a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d7469a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d7469a')) {
      api.createRecord('19d7469a', component.options)
    } else {
      api.reload('19d7469a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=19d7469a&scoped=true&", function () {
      api.rerender('19d7469a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS0i7i8aCvJ2/JS/comp/PopupBox.vue"
export default component.exports